import { Layout } from '@/shared/config/layout';

const state = {
  width: 0,
  height: 0,
  isTouch: false,
};

const mutations = {
  SET_WINDOW_SIZE(state, { width, height }) {
    state.width = width;
    state.height = height;
  }
};

const actions = {
  updateWindowSize({ commit }) {
    const size = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    commit('SET_WINDOW_SIZE', size);
    return size;
  },
  setupWindowSizeListener({ state, dispatch }) {
    dispatch('updateWindowSize');

    const handler = () => dispatch('updateWindowSize');
    window.addEventListener('resize', handler);
    state.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    return () => {
      window.removeEventListener('resize', handler);
    };
  }
};

const getters = {
  windowWidth: state => state.width,
  windowHeight: state => state.height,
  isWideScreen: state => state.width >= Layout.width.wd,
  isDesktop: state => state.width >= Layout.width.lg,
  isTablet: state => state.width >= Layout.width.md && state.width < Layout.width.lg,
  isMobile: state => state.width < Layout.width.md,
  isTouchDevice: state => state.isTouch,
  getBreakpoint: state => {
    if (state.width >= Layout.width.lg) {
      return 'lg';
    } else if (state.width >= Layout.width.md) {
      return 'md';
    } else {
      return 'sm';
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
